import { TRANSACTION_REQUEST_STATUS } from '../const';
import { Transaction } from '../hooks/use-transaction-details';

export type WithdrawalCancellationState = 'cancellable' | 'approved' | 'cancelled';

export const getWithdrawalCancellationState = (
    transaction?: Transaction | null
): WithdrawalCancellationState | null => {
    if (!transaction || transaction.action !== 'withdrawal') {
        return null;
    }
    if (transaction.status === 'WITHDRAWAL_CANCELLED') {
        return 'cancelled';
    }
    if (transaction.status !== 'WITHDRAWAL_ATTEMPT') {
        return null;
    }

    const statusEvents = Array.isArray(transaction.status_events) ? undefined : transaction.status_events;
    const reviewedStatus = statusEvents?.reviewed?.status;

    if (reviewedStatus === TRANSACTION_REQUEST_STATUS.SUCCESS) {
        return 'approved';
    }
    if (reviewedStatus === TRANSACTION_REQUEST_STATUS.FAILED) {
        return null;
    }
    return 'cancellable';
};
